<template>
  <div class="reports" v-if="reports.length">
    <div class="heading">
      <h1>{{$ml.get('My reports')}}</h1>
      <p>{{$ml.get('reports used')}}: {{numOfPrograms.used}} / {{numOfPrograms.max}}</p>
    </div>

    <!-- <div class="content">
      <div class="a-row" v-for="item in reports" :key="item.id" v-if="item.programName" >
        <p><b>{{ item.programName ? item.programName : 'report' }}</b> ({{ item.created_at }}) </p>
        <app-btn @click="downloadPdf(item.id, item.programName)" :loading="loading"> -->
          <!-- TODO добавить перевод -->
          <!-- download
        </app-btn>
        <app-btn @click="deletePdf(item.id)" :danger="true" v-if="$store.getters['user/data'].subsPlan != 'impact'">
          delete
        </app-btn>
      </div>

    </div> -->

    <div class="list">
      <div class="head" v-if="reports.length">
        <div class="col">
          {{$ml.get('Report name')}}
        </div>
        <div class="col start-date">
          {{$ml.get('Date')}}
        </div>
        <div class="col actions">
          {{$ml.get(`Actions`)}}
        </div>
      </div>
      <app-loading :loading="loading" pos="100px">
        <!-- <div v-if="!data.length" class="no-data"> -->
          <!-- <p>{{$ml.get(`You don't have any programs yet`)}}</p> -->
          <!-- <p>{{ program.you }}</p> -->
        <!-- </div> -->
        <!-- <template v-else> -->
          <!-- <ProgramListItem
            @update="sync"
            v-for="program in data"
            :key="program.id"
            :program="program"
          /> -->
        <!-- </template> -->
        <div
          class="reports-list-item row"
          v-for="item in reports"
          :key="item.id"
        >
        <!-- {{item}} -->
          <div class="col">
            <b>{{ item.programName ? item.programName : $ml.get('report')+' #'+item.id }}</b>
          </div>
          <div class="col">
            {{ item.created_at ? moment(item.created_at).format("Do MMM YYYY") : '-' }}
          </div>
          <div class="col buttons">
            <app-btn @click="downloadPdf(item.id, item.programName)" :loading="loading">
              {{$ml.get('download')}}
            </app-btn>
            <app-btn @click="deletePdf(item.id)" :danger="true" v-if="$store.getters['user/data'].subsPlan != 'impact'">
              {{$ml.get('delete')}}
            </app-btn>
          </div>
        </div>
      </app-loading>
    </div>

    <AppPagination
      v-if="Number(pages) > 1"
      :start="0"
      :length="Number(pages)"
      :event="true"
      @pagEvent="changePage"
    />
  </div>

  <div class="empty" v-else>
    <empty-content :title="$ml.get('You still don\'t have reports!')">
      <template v-slot:content>
        <app-btn :to="`/dashboard/programs/list/0`">{{$ml.get('Programs')}}</app-btn>
      </template>
    </empty-content>
  </div>

</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import AppPagination from '@/components/common/AppPagination'
import API from '@/api'

export default {
  data() {
    return {
      moment: moment,
      reports: {},
      loading: false,
      form: {
        page: 1,
        take: 24
      },
      pages: 0
    }
  },
  created() {
    this.load();
    this.$store.dispatch('user/availableReports');
  },
  computed: {
    ...mapGetters({
      numOfPrograms: 'user/availablePrograms',
    }),
  },
  methods: {
    //=================================================================================
    load() {
      return API.reports.load(this.form)
        .then(res => {
          this.reports = res.data.pdfs;
          this.pages = res.data.pages;
          try {
              let result = JSON.parse(JSON.stringify(res));
              console.log(result.data.message);
              if (result.data.message == 'Please buy a plan!') {
                this.$notify({
                  group: "notices",
                  title: this.$ml.get(
                    `Please buy a plan before searching reports.`
                  ),
                  type: "error",
                });
              }
            } catch (e) {}
        })
    },
    //=================================================================================
    async downloadPdf (id, name) {
      // this.loading = true;
      var result = await API.pdf.getPdfById(id);
      var blob = new Blob([result.data], {type: 'application/pdf'});
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      if(!name) {
        name = 'report #'+id;
      }
      link.download = name + '.pdf';
      link.click();
      // this.loading = false;
    },
    deletePdf(id) {
      this.loading = true;
      return API.reports.deletePdf(id)
        .then(res => {
          this.load();
          this.loading = false;
          this.$store.dispatch('user/availableReports');
        })
    },
    changePage(page) {
      this.form.page = page+1;
      this.load();
      console.log(page);
    }
  },
  components: {
    AppPagination
  }
}
</script>

<style lang="scss" scoped>
.list {
  flex-grow: 1;
}
.reports {
  display: flex;
  flex-direction: column;

  .content {
    // max-width: 500px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    // justify-content: stretch;

    > .a-row {
      margin: 10px 0;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 16px;
      border-bottom: 1px solid #e0e0e0;
      p {
        flex-grow: 1;
        margin: 0;
        // border-bottom: 1px dotted #2c3e50;
      }
      button {
        min-width: 110px;
        margin-left: 8px;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.reports {
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
  .head {
    display: flex;
    flex-direction: row;
    align-items: center;
    // justify-content: space-between;
    border-bottom: 1px solid #E4E5E6;
    user-select: none;
    .col {
      // flex-grow: 2;
      flex-basis: 33.33%;
      padding: 8px;
      text-transform: uppercase;
      font-size: 12px;
      padding-bottom: 8px;
      margin-bottom: 8px;
      font-weight: 500;
      color: #8B8D91;
      &.actions, &.fert-method {
        flex-basis: 10%;
      }
    }
  }
  .list {
    overflow: hidden;
    padding: 8px 12px;
    background-color: #fff;
    border-radius: 5px;
    flex-grow: 2;
    position: relative;
    border: 1px #E4E5E6 solid;
  }
  .no-data {
    color: rgb(211, 211, 211);
    font-weight: 500;
    font-size: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media (max-width:768px) {
    .head {
      display: none;
    }
  }
}
.reports-list-item {

  &:last-child {
    border-bottom: 0;
  }

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #E4E5E6;

  .col {
    // flex-grow: 2;
    flex-basis: 33.33%;
    padding: 8px;
    line-height: 1.5;
    &.buttons {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      .btn {
        margin-right: 16px;
      }
    }

    // &.fert-method {
    //   text-transform: capitalize;
    // }
    // &.actions, &.fert-method {
    //   flex-basis: 10%;
    // }

    // .delete {
    //   width: 30px;
    //   height: 30px;
    //   transition: background 0.3s ease;
    //   border-radius: 100%;
    //
    //   svg {
    //     fill: #E8282F;
    //   }
    //
    //   &:hover {
    //     background: rgba(#E8282F, 0.15);
    //   }
    // }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    > * {
      margin-bottom: 4px;
      // &.actions {
      //   display: none;
      // }
    }
  }
}
</style>
